import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV, COMPANY } from "@/lib/site";

const TOP_NAV = NAV.filter((n) => n.to !== "/careers");

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => setOpen(false), [location.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-300 ${
        scrolled ? "border-line bg-paper/85 backdrop-blur-xl" : "border-transparent bg-paper/60 backdrop-blur-md"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-[1400px] items-center justify-between px-6 md:px-12 lg:px-16">
        <Link to="/" data-testid="logo-home" className="group flex items-center gap-2.5">
          <span className="flex h-8 w-8 items-center justify-center bg-ink text-paper font-display text-sm font-bold">
            C
          </span>
          <span className="font-display text-lg font-bold tracking-tight text-ink leading-none">
            CCA
            <span className="ml-2 hidden font-mono text-[10px] font-normal uppercase tracking-[0.2em] text-subtext sm:inline">
              Pipeline Development
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-7 lg:flex">
          {TOP_NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.to.replace("/", "")}`}
              className={({ isActive }) =>
                `font-mono text-[12px] uppercase tracking-[0.12em] transition-colors hover:text-navy ${
                  isActive ? "text-navy" : "text-subtext"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center border border-line lg:hidden"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="border-t border-line bg-paper lg:hidden">
          <nav className="flex flex-col px-6 py-4">
            {TOP_NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className="border-b border-line py-3 font-mono text-sm uppercase tracking-[0.12em] text-ink"
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
